export default {
  /////////GIT

  //通用
  baseUrl: process.env.API_ROOT,



  deviceBlackListIndexAPI:"/adm/v1/device/blacklist/index", //获取机型地区限制列表 model 机型，region 地区，page，page_size region 地区是字符串，可以 国省市，如果多个，如：中国广东深圳，则传中国|广东|深圳。|竖线分割
  deviceBlackListAddAPI:"/adm/v1/device/blacklist/add",//  添加机型地区限制 参数：model 机型，region 地区，activation_time 激活时间戳10位数 ，type 1：点歌，2：酷狗，3：全民，4：APP，remarks：备注 region： 地区是字符串，可以 国省市，如果多个，如：中国广东深圳，则传中国|广东|深圳。|竖线分割
  deviceBlackListDeleteAPI:"/adm/v1/device/blacklist/delete",//删除机型地区限制  POST，参数：id

  // 粤语点歌管理
  yueyuSongAuthIndexAPI: "/adm/v1/yueyu/song/auth/index", //查询授权列表 GET 参数：mac，page，page_size,status,
  yueyuSongAuthAddAPI: "/adm/v1/yueyu/song/auth/add", //添加授权 POST 参数：mac，remarks 1：授权，2：取消授权
  yueyuSongAuthDeleteAPI: "/adm/v1/yueyu/song/auth/delete", //删除授权 POST 参数：mac
  yueyuSongMemberIndexAPI: "/adm/v1/yueyu/song/member/index", //查询会员列表 GET 参数：mac，page，page_size
  yueyuSongMemberEditAPI: "/adm/v1/yueyu/song/member/edit", //编辑会员 POST 参数：mac，vip_name，open_time，expire_time；access_token 为管理员登录 token（network 自动附加）
  yueyuSongOrderIndexAPI: "/adm/v1/yueyu/song/order/index", //粤语订单流水 GET 参数：mac，order_number，start_time，end_time，page，page_size

  userAmountIndexAPI: "/adm/v1/customized/user/settle/user_amount/index", //查询用户结清列表
  userSettleRecordIndexAPI: "/adm/v1/customized/user/settle/record/index", //查询结清记录列表
  userSettleAddAPI: "/adm/v1/customized/user/settle/add", //结清用户 POST 参数：cust_uuid，settle_amount:本次结清金额，不传或小于等于 `0` 时，默认结清当前全部可结清金额，remark

  gekuRegionV2ListAPI: "/adm/v1/member/geku/region/v2/list",
  gekuRegionV2DeleteAPI: "/adm/v1/member/geku/region/v2/delete", //
  gekuDefaultListAPI: "/adm/v1/member/geku/default/query", //默认地区配置歌库列表

  apkDeviceResetBatchActivationAPI: "/adm/v1/apk/device/reset/batch/activation", //批量重置APK版本激活 POST 参数：mac_list: ["mac1", "mac2", ...]  mac地址列表，access_token: token

  youtubeKeyCheckOneAPI: "/adm/v1/youtube/key/check_one", //检查YouTubeKey是否存在 GET 参数：key

  // 机型区域指定歌库列表
  gekuRegionAddAPI: "/adm/v1/member/geku/region/add", //添加机型区域指定歌库 POST 参数：model_uuid —— 机型唯一标识，type_uuid_cn —— 国内歌库，type_uuid_hw —— 海外歌库 ，province  ——  省份 ，city —— 地区 备注：province 与 city 二填一，其余
  gekuRegionListAPI: "/adm/v1/member/geku/region/list", //获取机型指定歌库地区列表API GET 参数： category_name1，category_name2，province，city，page，page_size
  gekuRegionDeleteAPI: "/adm/v1/member/geku/region/delete", //删除机型区域指定歌库 POST 参数：id，type:1单个删除，2：一键全删

  //订单管理：APP点歌订单
  apkVipPaymentIndexAPI: "/adm/v1/apk/vip/payment/index", //查询：
  apkVipPaymentExcleAPI: "/adm/v1/apk/vip/payment/excle", //导出：

  //20260304
  // OTA 升级包管理
  packageListAPI: "/adm/v1/ota/package/list", // 分页查询升级包列表
  packageUploadAPI: "/adm/v1/ota/package/upload", //上传 OTA 升级包
  packageDeleteAPI: "/adm/v1/ota/package/delete", //删除升级包
  bindAddByModelAPI: "/adm/v1/ota/bind/add_by_model", //将一个 OTA 包绑定到一个或多个机型
  bindAddByMacAPI: "/adm/v1/ota/bind/add_by_mac", //为单台设备（MAC）绑定一个 OTA 包
  bindListAPI: "/adm/v1/ota/bind/list", //查询绑定策略列表（联表包信息）
  bindDeleteAPI: "/adm/v1/ota/bind/delete", //删除绑定策略
  bindEditAPI: "/adm/v1/ota/bind/edit", //编辑绑定策略（版本范围 / 默认 / 备注）
  upgradeLogListAPI: "/adm/v1/ota/upgrade_log/list", //设备升级记录日志 询条件mac

  // 20260127新增接口
  cpuidMacBindModelIndexAPI: "/adm/v1/cpuid/mac/bind/model/index", //获取MAC绑定机型列表 GET 参数：mac（可选 page，page_size 分页
  cpuidMacBindModelAddAPI: "/adm/v1/cpuid/mac/bind/model/add", //新增MAC绑定机型 POST 参数：mac（必填,去掉 : ） model（必填） remarks（可选）
  cpuidMacBindModelDeleteAPI: "/adm/v1/cpuid/mac/bind/model/delete", //删除MAC绑定机型 POST 参数：mac（必填,不需要去掉： 原mac）
  // 20251226新增接口 POST请求 音集协会员转移   old_mac、new_mac、is_reset
  manageTransferMacAPI: "/adm/v1/manage/transfer_mac",

  /**
   * 出厂套餐MAC管理接口文档
   */
  // 20251126新增接口
  factoryPackageMacModelListAPI: "/adm/v1/factorypackagemac/modelList", // 机型指定配置激活列表 GET 传参：model_uuid  - 机型UUIDpage (可选) - 页码，默认0page_size (可选) - 每页数量，默认0
  factoryPackageMacAddModelAPI: "/adm/v1/factorypackagemac/addModel", //新增机型 POST 传参：model_uuid (必填) - 机型UUID goods_name (必填) - 出厂套餐名称 attribute_name (必填) - 类型（默认：MONTH）attribute_value (必填) - 套餐属性值
  factoryPackageMacDeleteModelAPI: "/adm/v1/factorypackagemac/deleteModel", //删除机型 POST 传参：model_uuid (必填) - 机型UUID 说明： 删除前会验证该机型下是否有MAC，如有则无法删除
  factoryPackageMacListAPI: "/adm/v1/factorypackagemac/macList", // 查询MAC列表 GET 传参：mac_model_uuid (必填) - 机型UUID mac (可选) - MAC地址（模糊查询） page (可选) - 页码，默认0 page_size (可选) - 每页数量，默认0
  factoryPackageMacAddMacAPI: "/adm/v1/factorypackagemac/addMac", // 新增MAC POST 传参：mac (必填) - MAC地址 mac_model_uuid (必填) - 机型UUID remark (可选) - 备注
  factoryPackageMaccDeleteMacAPI: "/adm/v1/factorypackagemac/deleteMac", // 删除MAC POST 传参：mac (必填) - MAC地址 access_token (必填) - 访问令牌
  // 20251125新增接口
  memberMacGekuAddAPI: "/adm/v1/member/mac/geku/add", //设置MAC使用定制歌库 PSOT 参数：mac，type_uuid_cn，type_uuid_hw，remark
  memberMacGekuDeleteAPI: "/adm/v1/member/mac/geku/delete", //删除MAC歌库 PSOT 参数：mac
  memberGekuMacListAPI: "/adm/v1/member/geku/mac/list", //获取MAC歌库定制列表 GET 参数：mac, page,page_size

  // 20251103新增借口
  apkMemberExperienceIndexAPI: "/adm/v1/apk/member/experience/index", // 获取APK机型体验套餐列表 GET参数 ：model_name 机型名称，page，page_size
  apkMemberExperienceAddAPI: "/adm/v1/apk/member/experience/add", // 新增APK机型体验套餐 POST参数 ：「device_id：机型UUID」 ，「vip_name：套餐名称」，「vip_days：套餐天数 单位天 数值类型」,「vip_num：套餐数目  数值类型」，「type：默认传1 」

  // 20250925新增接口
  //批量新增人工会员
  manageDowngradeBatchMacAPI: "/adm/v1/manage/downgrade/batch/mac", //POST参数：mac  （不带:）type(1：国内， 2：海外)，name：套餐名称，start_time：套餐开始时间戳10位，end_time，amount：歌曲数目，access_token: token
  // 获取APK版本激活列表
  deviceActivationIndexAPI: "/adm/v1/apk/device/activation/index", //GET 参数：mac  （不带:）page:number,page_size:number,access_token: token
  // 重置APK版本激活
  deviceResetActivationAPI: "/adm/v1/apk/device/reset/activation", //POST 参数：mac:string. access_token: token

  //20250922新增接口
  /**
   * 新增：人工限速会员
   * 接口：/adm/v1/manage/downgrade/update  GET
   * 参数：uuid，
   * mobile：mac地址，
   * type(1：国内， 2：海外)，
   * name：套餐名称，
   * start_time：套餐开始时间戳10位，
   * end_time，
   * amount：歌曲数目，
   * access_token: token
   *  */

  manageDowngradeUpdateAPI: "/adm/v1/manage/downgrade/update",
  // 202050903新增接口
  missingSongFeedbackListAPI: "/adm/v1/missing/song/feedback/list", //GET，参数 mac，status状态1：未处理，2：处理中，3：已处理 page, page_size
  feedbackSongResponseAPI: "/adm/v1/feedback/song/response", //回复反馈:参数uuid, message
  /**
   *
   * 新增接口：经销商模块功能
   * 1：获取经销商账号列表：/adm/v1/apk/dealer/user/index ，GET 参数：nickname 经销商账号查询，page，page_size 分页
   * 2：新增经销商用户会员套餐兑换资格数：/adm/v1/apk/dealer/user/cdkey/add，POST
   * 参数：user_uuid：用户的UUID，（字符类型，必填）
   * 参数：membership_name：资格套餐名称，（字符类型，必填）
   * 参数：attribute_name：资格套餐时间单位，（字符类型，必填，默认填写：MONTH）
   * 参数：attribute_value：资格套餐时间值，（字符类型，必填，月份1-12）
   * 参数：first_year_inland_num：首年资格数，（数值类型，必填）
   * 参数：next_year_inland_num：次年资格数，（数值类型，必填）
   * 参数：first_year_abroad_num：海外首年资格数，（数值类型，必填）
   * 参数：next_year_abroad_num：海外次年资格数，（数值类型，必填）
   * 参数：notes：备注信息，（字符类型，必填）
   * 3：追加经销商用户会员套餐兑换资格数：/adm/v1/apk/dealer/user/cdkey/update，POST
   * 参数：uuid：会员兑换资格套餐的UUID，（字符类型，必填）
   * 参数：first_year_inland_num：首年资格数，（数值类型，必填）
   * 参数：next_year_inland_num：次年资格数，（数值类型，必填）
   * 参数：first_year_abroad_num：海外首年资格数，（数值类型，必填）
   * 参数：next_year_abroad_num：海外次年资格数，（数值类型，必填）
   * 4：获取经销商会员兑换资格列表：/adm/v1/apk/dealer/membership/index ，GET 参数：user_uuid ：用户账号的UUID，page，page_size 分页
   * 5：获取经销商会员兑换资格的实体CDK列表：/adm/v1/apk/dealer/membership/index ，GET 参数：uuid ：会员兑换资格套餐的UUID，page，page_size 分页
   * 5：获取经销商会员兑换资格的实体CDK列表：/adm/v1/apk/dealer/membership/cdk/index ，GET 参数：uuid ：会员兑换资格套餐的UUID，page，page_size 分页
   * 6：新增经销商二级账号：/adm/v1/apk/dealer/user/add，POST
   * 参数：channel_group_uuid：渠道组的UUID，（字符类型，必填）
   * 参数：account：账号，（字符类型，必填）
   * 参数：password：密码，（字符类型，必填）
   * 参数：nickname：昵称，（字符类型，必填）
   * 参数：address：地址，（字符类型，必填）
   * 参数：phone：手机号，（字符类型，必填）
   */

  /** 页面1：音集协弹窗页面   */
  // SDK管控全局开关配置
  YJXSdkPopGlobalSwitchAPI: "/adm/v1/yjx/sdk/pop/global/switch", //POST 参数  status （1：开启，2:关闭）
  // 获取SDK全局开关状态
  YJXSdkPopGlobalSwitchGetAPI: "/adm/v1/yjx/sdk/pop/global/switch/get", //GET
  // 批量新增管控MAC
  YJXSdkPopConfigMacAddAPI: "/adm/v1/yjx/sdk/pop/config/mac/add", //参数 mac，remarks  MAC不带
  // 获取管控列表 MAC
  YJXSdkPopConfigIndexMacAPI: "/adm/v1/yjx/sdk/pop/config/index_mac", //GET  参数 mac，  type1:机型，2：是MAC，page，page_size
  //删除配置
  YJXSdkPopConfigDeleteAPI: "/adm/v1/yjx/sdk/pop/config/delete", //参数 mac， model_uuid, type

  /** 页面2：音集协SDK会员页面 */
  YJXSdkMemberIndexAPI: "/adm/v1/yjx/sdk/member/index", //GET  参数 mac：是MAC，page，page_size

  dealerUserIndexAPI: "/adm/v1/apk/dealer/user/index", //获取经销商账号列表 GET 参数：nickname 经销商账号查询，page，page_size 分页
  deviceGoodsIndexAPI: "/adm/v1/apk/device/goods/index", //获取商品列表
  dealerUserCdkeyAddAPI: "/adm/v1/apk/dealer/user/cdkey/add",
  dealerUserCdkeyUpdateAPI: "/adm/v1/apk/dealer/user/cdkey/update",
  dealerMembershipIndexAPI: "/adm/v1/apk/dealer/membership/index",
  dealerMembershipCdkIndexAPI: "/adm/v1/apk/dealer/membership/cdk/index",
  dealerUserAddAPI: "/adm/v1/apk/dealer/user/add",
  // apkdevice/model-management
  //机型渠道组
  channelGroupIndexAPI: "/adm/v1/apk/channel/group/index", //获取机型渠道组列表:GET 参数：channel_group_name 渠道组名称，page，page_size 分页
  channelGroupAddAPI: "/adm/v1/apk/channel/group/add", //新增机型渠道组 POST 参数：channel_group_name 渠道组名称
  channelGroupDeleteAPI: "/adm/v1/apk/channel/group/delete", //删除机型渠道组：POST 参数：uuid 渠道唯一标识
  dealerCdkIndexAPI: "/adm/v1/apk/dealer/cdk/index", //GET 获取渠道所有CDK列表 参数：cdkey cdk查询，status：0：未使用，1：已使用，used_mac：已使用 mac查询，channel_group_uuid：渠道UUID，渠道组查询，page，page_size 分页
  // apkdevice/model-management
  channelModelAPI: "/adm/v1/apk/channel/model/index", //获取APK机型列表
  channelModelAddAPI: "/adm/v1/apk/channel/model/add", //新增APK机型
  channelModelDeleteAPI: "/adm/v1/apk/channel/model/delete", //APK机型
  channelModelEditAPI: "/adm/v1/apk/channel/model/edit", //编辑APK机型

  channelModelAppendMacAPI: "/adm/v1/apk/channel/model/append/mac", //追加机型的MAC地址数量 uuid 机型唯一标识，num_mac  INT，表示添加机型的时候要生成多少个MAC
  //APK-version/CDK-generate-management
  channelCdkeyAPI: "/adm/v1/apk/channel/cdkey/index", //获取机型CDK列表
  channelCdkeyAddAPI: "/adm/v1/apk/channel/cdkey/add", //新增CDK机型
  //login:'/shareUser/login',

  login: "/adm/v1/user/login",
  logout: "/adm/v1/user/logout",
  // get_user_info:'/shareUser/get-info',
  get_user_info: "/adm/v1/user/get-info",
  clear_cache: "/adm/v1/cache/clear",
  // roles_index:'/shareUser/roles/index',
  roles_index: "/adm/v1/roles/index",
  roles_save: "/adm/v1/roles/save",
  roles_detail: "/adm/v1/roles/detail",
  user_index: "/adm/v1/user/index",
  user_save: "/adm/v1/user/save",
  user_detail: "/adm/v1/user/detail",
  user_reset_password: "/adm/v1/user/save-pwd",
  user_update_password: "/adm/v1/user/update-pwd",
  category_index: "/adm/v1/category/index",
  category_save: "/adm/v1/category/save",

  menu_index: "/adm/v1/menu/index",
  menu_save: "/adm/v1/menu/save",
  menu_delete: "/adm/v1/menu/delete",
  menu_children: "/adm/v1/menu/children",
  menu_rights: "/adm/v1/menu/rights",

  news_index: "/adm/v1/news/index",
  news_save: "/adm/v1/news/save",
  news_detail: "/adm/v1/news/detail",
  member_index: "/adm/v1/member/index",
  member_save: "/adm/v1/member/save",
  banner_index: "/adm/v1/banner/index",
  banner_save: "/adm/v1/banner/save",
  banner_detail: "/adm/v1/banner/detail",
  stats_member_count: "/adm/v1/stats/member",
  stats_member_graph: "/adm/v1/stats/member-graph",

  /**
   *主页
   */
  home_statistics: "/adm/v1/home/getDataStatistics", //三条统计数据
  home_LogRecentOperationList: "/adm/v1/home/LogRecentOperationList", //获取当前用户最近的操作记录
  home_macRegister_nearlyayear: "/adm/v1/home/macRegister_nearlyayear", //获取最近7天的点歌机激活数
  home_song_nearlyayear: "/adm/v1/home/song_nearlyayear", //获取最近7天的点歌机下载歌曲数
  home_song_yesterday: "/adm/v1/home/song_yesterday", //获取昨天每个时间段的歌曲下载数

  merchant_add: "/adm/v1/merchant/add", //新增入网商户

  /**
   * 扫描付费
   */
  prohibit_index: "/adm/v1/prohibit/index", //获取禁用机型列表
  prohibit_add: "/adm/v1/prohibit/add", //批量禁用机型
  prohibit_delete: "/adm/v1/prohibit/delete", //删除禁用机型
  scanpay_index: "/adm/v1/scanpay/index", //获取扫码付费开通机型页面 (趣支付)
  scanpay_add: "/adm/v1/scanpay/add", //添加扫码付费启用mac  (趣支付)
  scanpay_delete: "/adm/v1/scanpay/delete", //删除扫码付费启用mac （趣支付)

  /**mac
   *  机器管理
   */
  ipaddress_idenx: "/adm/v1/ipaddress/index", //获取机器ip地址所属列表
  ipaddress_excel: "/adm/v1/ipaddress/excel", //获取机器ip地址所属列表
  ipaddress_city_count: "/adm/v1/ipaddress/city/count", //获取城市机器数量统计
  setmeal_add: "/adm/v1/setmeal/add", //批量上传exclMac设置套餐
  setmeal_list: "/adm/v1/setmeal/list", //获取mac批量上传记录列表
  setmeal_doc: "/adm/v1/setmeal/view_documents", //查看MAC上传的文档
  setmeal_doc: "/adm/v1/setmeal/view_documents", //查看MAC上传的文档
  setmeal_addMac_setMeal: "/adm/v1/setmeal/addMac_setMeal", //批量添加mac并设置套餐
  modlename_index: "/adm/v1/modlename/index", //一级机型列表
  modlename_index_son: "/adm/v1/modlename/index_son", //二级机型列表
  modlename_get_template: "/adm/v1/goods/get_template", //获取机型套餐
  modlename_add_modlename: "/adm/v1/modlename/add_modlename", //添加修改一级机型
  modlename_add_modlename2: "/adm/v1/modlename/add_modlename2", //添加修改二级机型
  itervalversion_index: "/adm/v1/itervalversion/index", //获取区间版本列表
  itervalversion_add_interval_version:
    "/adm/v1/itervalversion/add_interval_version", //编辑区间版本
  itervalversion_application_index: "/adm/v1/itervalversion/application_index", //获取应用版本列表
  itervalversion_add_interval_application_version:
    "/adm/v1/itervalversion/add_interval_application_version", //编辑应用版本
  itervalversion_add_interval_version_mobile:
    "/adm/v1/itervalversion/category_mobile", //新增可用升级的MAC地址
  itervalversion_index_interval_version_mobile:
    "/adm/v1/itervalversion/category_mobile_index", //获取可使用升级功能的MAC列表
  combination_group_index: "/adm/v1/combination/group/index", //获取全民套餐集合

  /**
   * 数据管理
   */
  itervalversion_upload_version: "/adm/v1/itervalversion/upload_version", //上传版本包
  itervalversion_upload_list: "/adm/v1/system/systemUpdateIndex", //系统信息升级列表
  itervalversion_upload_get: "/adm/v1/system/systemUpdateGetID", //系统信息升级列表详细信息
  itervalversion_upload_edit: "/adm/v1/itervalversion/upload_version_edit", //编辑文件信息
  itervalversion_upload_delete: "/adm/v1/itervalversion/upload_version_delete", //删除文件信息

  modlename_queryModel: "/adm/v1/modlename/queryModel", //获取机型
  modlename_queryModelNew: "/adm/v1/modlename/queryModel/new", //获取机型新版

  /**
   * 点歌机信息管理
   */
  membermanage_index: "/adm/v1/manage/index", //获取点歌机信息列表
  membermanage_get: "/adm/v1/manage/get", //根据uuid获取点歌机详细信息
  membermanage_update: "/adm/v1/manage/update", //编辑点歌机
  membermanage_index_disabled: "/adm/v1/manage/index_disabled", //禁用点歌机信息列表
  membermanage_index_status: "/adm/v1/manage/edit_status", //修改点歌机状态
  membermanage_index_delete: "/adm/v1/manage/delete_mobile", //删除点歌机
  membermanage_index_add: "/adm/v1/manage/add_mobile", //添加点歌机
  membermanage_overseas_update: "/adm/v1/manage/overseas_update", //编辑海外点歌机
  membermanage_overseas_reset: "/adm/v1/manage/edit_reset", //重置点歌机
  membermanage_service_index: "/adm/v1/manage/service/index", //获取点歌机信息列表 --- 售后专用
  manage_bathch_mac: "/adm/v1/manage/batch/mac", //批量开通MAC会员

  /**
   * 点歌机操作日志记录
   */
  mamberlogs_index: "/adm/v1/memberLogs/index", //获取日志记录列表
  mamberlogs_mac_index: "/adm/v1/memberLogs/mac/index", //获取点歌机VIP操作详细日志列表
  mamberlogs_vip_download_mac: "/adm/v1/memberLogs/index/mac/vip/download", //获取日志会员下载记录数
  memberLogsAddIndex: "/adm/v1/memberLogs/add/index", //日志上报列表
  apiOperateLogIndexAPI: "/adm/v1/api/operate/log/index", //全日志列表 GET 参数：user_name,user_id,api_path,http_method,http_status,start_time,end_time,page,page_size

  /**
   * 出厂套餐管理
   */
  factorypackage_add: "/adm/v1/factorypackage/add", //添加出厂套餐
  factorypackage_modelShuttle: "/adm/v1/factorypackage/modelShuttle", //穿梭框机型
  factorypackage_index: "/adm/v1/factorypackage/index", //获取出厂套餐列表
  factorypackage_getuuid: "/adm/v1/factorypackage/GetUuid", //获取出厂套餐列表详细信息
  factorypackage_edituuid: "/adm/v1/factorypackage/edit", //根据uuid编辑信息
  factorypackage_deleteuuid: "/adm/v1/factorypackage/delete", //根据uuid删除
  factoryactivation_index: "/adm/v1/factoryactivation/index", //出厂机器激活列表
  factoryactivation_get: "/adm/v1/factoryactivation/get", //出厂机器详细信息
  factoryactivation_reset_delete: "/adm/v1/factoryactivation/reset_delete", //重新激活机器
  factoryactivation_delay_guarantee:
    "/adm/v1/factoryactivation/delay_guarantee", //延长机器保修期

  /**
   * 商品管理
   */
  goods_set_meal_list: "/adm/v1/goods/set_meal_list", //商品套餐
  goods_add: "/adm/v1/goods/add", //添加商品
  goods_itme_add: "/adm/v1/goods/item_add", //添加商品类目套餐
  goods_list_off_shelf: "/adm/v1/goods/list/off_shelf", //获取商品套餐列表
  goods_get_uuid: "/adm/v1/goods/get_uuid", //获取商品详细信息
  goods_get_edit: "/adm/v1/goods/stores/edit", //编辑套餐
  goods_get_status: "/adm/v1/goods/stores/status", //上下架
  goods_get_delete: "/adm/v1/goods/stores/delete", //删除商品

  voice_goods_add: "/adm/v1/voice/good/add", //添加语音商品
  voice_goods_list: "/adm/v1/voice/good_list", //获取语音商品列表
  voice_goods_get_uuid: "/adm/v1/voice/good_uuid", //获取语音商品详细信息
  voice_goods_edit: "/adm/v1/voice/stores/edit", //编辑语音商品信息
  voice_goods_delete: "/adm/v1/voice/stores/delete", //删除语音商品
  voice_goods_status: "/adm/v1/voice/stores/status", //语音商品上下架

  svip_goods_add: "/adm/v1/svip/good/add", //添加SVIP商品
  svip_goods_list: "/adm/v1/svip/good_list", //获取SVIP商品列表
  svip_goods_get_uuid: "/adm/v1/svip/good_uuid", //获取SVIP商品详细信息
  svip_goods_edit: "/adm/v1/svip/stores/edit", //编辑SVIP商品信息
  svip_goods_delete: "/adm/v1/svip/stores/delete", //删除SVIP商品
  svip_goods_status: "/adm/v1/svip/stores/status", //SVIP商品上下架

  /**
   * 歌单数据管理
   */
  song_list_type_list: "/adm/v1/song/list_type/list", //获取歌单类型数据
  song_list_group_list: "/adm/v1/song/list_group/list", //获取歌单组数据
  song_list_data_add: "/adm/v1/song/list_data/add", //上传歌单数据
  song_list_information: "/adm/v1/song/list/information", //获取歌单信息数据列表
  song_list_information_delete: "/adm/v1/song/list/information_delete", //删除歌单数据
  song_item_add: "/adm/v1/song/item/add", //添加歌单组
  song_item_delete: "/adm/v1/song/item/delete", //删除歌单组
  song_item_edit_status: "/adm/v1/song/item/edit_status", //更改歌单组状态
  song_item_mac_list: "/adm/v1/song/item/mac/list", //获取歌单组指定MAC数据列表
  song_item_mac_add: "/adm/v1/song/item/mac/add", //设置MAC指定歌单组
  song_item_mac_delete: "/adm/v1/song/item/mac/delete", //取消MAC指定歌单组的关联
  wechat_songlist_list_name: "/adm/v1/wechat/songlist/list_name", //获取微信歌单序号列表
  wechat_songlist_list_add: "/adm/v1/wechat/songlist/add", //添加微信歌单序号
  wechat_songlist_list_binding_list: "/adm/v1/wechat/songlist/binding/list", //获取微信歌单组序号列表
  wechat_songlist_list_binding_model_add:
    "/adm/v1/wechat/songlist/binding_model", //获取微信歌单组序号列表
  wechat_songlist_list_binding_model_delete:
    "/adm/v1/wechat/songlist/binding_delete", //删除机型绑定信息
  song_list_type_add: "/adm/v1/song/list/type/add", //添加歌单类型
  song_list_type_delete: "/adm/v1/song/list/type/delete", //删除歌单类型

  /**
   * 定制歌库管理
   */
  member_geku_list: "/adm/v1/member/geku/list", //获取歌库定制列表
  member_geku_add: "/adm/v1/member/geku/add", //添加歌库定制列表
  member_geku_delete: "/adm/v1/member/geku/delete", //删除歌库定制列表
  member_geku_get: "/adm/v1/member/geku/getID", //获取歌库详细信息
  member_geku_edit: "/adm/v1/member/geku/edit", //修改定制歌库信息
  member_geku_type_list: "/adm/v1/member/geku/type/list", //获取歌库类型管理数据
  member_geku_type_add: "/adm/v1/member/geku/type/add", //新增歌库类型
  member_geku_type_edit: "/adm/v1/member/geku/type/edit", //编辑歌库类型
  member_geku_type_delete: "/adm/v1/member/geku/type/delete", //删除歌库类型

  /**
   * 天音下载管理
   */
  tianyin_download_geku_add: "/adm/v1/tianyin/song/geku_add", //指定机型使用歌库
  tianyin_download_geku_list: "/adm/v1/tianyin/song/geku_list", //指定机型下载歌库设置列表
  tianyin_download_geku_delete: "/adm/v1/tianyin/song/geku_delete", //取消指定机型歌库设置
  tianyin_download_geku_get: "/adm/v1/tianyin/song/geku_getID", //获取详细信息
  tianyin_download_geku_edit: "/adm/v1/tianyin/song/geku_edit", //修改信息

  /**
   * 服务器管控
   */
  server_index: "/adm/v1/server/index", //获取服务器列表
  server_add: "/adm/v1/server/add", //新增服务器
  server_edit: "/adm/v1/server/edit", //编辑服务器
  server_mac_index: "/adm/v1/server/mac/index", //获取服务器信息列表
  server_delete: "/adm/v1/server/delete", //删除服务器

  /**
   * 订单管理
   */
  order_cdn_index: "/adm/v1/cdn/payment/index", //获取CDN订单流水
  orderCdnExcle: "/adm/v1/cdn/payment/excle", //导出CDN订单流水
  order_voice_index: "/adm/v1/voice/payment/index", //获取语音订单流水
  order_svip_index: "/adm/v1/svip/payment/index", //获取SVIP订单流水
  order_skinmall_index: "/adm/v1/skinmall/payment/index", //获取皮肤商城订单流水
  order_refund_index: "/adm/v1/refund/order/list", //退款订单列表
  order_refund_alipay: "/adm/v1/aliPay/tradeRefund", //支付宝退款
  order_refund_wechat: "/adm/v1/weChat/refund", //微信退款
  order_kugou_index: "/adm/v1/kugou/vip/payment/index", //获取酷狗订单流水
  order_kugou_excle: "/adm/v1/kugou/vip/payment/excle", //酷狗订单流水导出
  comboPackageOrderIndexAPI: "/adm/v1/combo/package/order/index", //点歌全民会员订单流水 GET 参数：device_mac，order_no，user_id，start_time，end_time，page，page_size（pay_status=2已支付）
  wxMerchantAllList: "/adm/v1/merchant/all/list", //当心微信商户配置收款信息

  order_wxmeber_index: "/adm/v1/wx/member/index", //小程序会员订单
  order_wxmeber_excle: "/adm/v1/wx/member/excle", //小程序会员导出
  order_wxmember_statistics: "/adm/v1/statistics/wx/member/total", //小程序会员统计

  /**
   * 皮肤管理
   */
  UploadSkinFile: "/adm/v1/system/skin/upload", //上传皮肤文件
  package_add: "/adm/v1/skin/package/add", //上传皮肤包信息
  group_index: "/adm/v1/skin/group/index", //获取皮肤组列表
  skin_mall_tagtype_index: "/adm/v1/skin/tagtype/index", //获取皮肤标签列表
  skin_mall_tagtype_add: "/adm/v1/skin/tagtype/add", //添加皮肤标签
  skin_mall_tagtype_edit_sort: "/adm/v1/skin/tagtype/edit_sort", //设置皮肤标签排序值
  skin_mall_index: "/adm/v1/skin/mall/index", //获取皮肤列表信息
  skin_version_index: "/adm/v1/skin/version/index", //获取版本编号列表信息
  skin_mall_version_add: "/adm/v1/skin/version/add", //添加皮肤版本号
  skin_mall_skin_uuid: "/adm/v1/skin/mall/skin_uuid", //获取皮肤包详细信息
  skin_mall_package_version_add: "/adm/v1/skin/package/version_add", //上传皮肤版本包信息
  skin_mall_package_index: "/adm/v1/skin/mall/package/index", //获取皮肤下面的包版本信息列表
  skin_mall_package_version_edit: "/adm/v1/skin/package/version_edit", //更新皮肤版本包信息
  skin_mall_package_edit_info: "/adm/v1/skin/mall/edit_info", //修改皮肤基础信息
  skin_mall_package_synchronization: "/adm/v1/skin/package/synchronization", //同步接口

  /**
   * CPUID列表管理
   */
  cpuIdIndex: "/adm/v1/cpuid/mac/index", //获取CPUID列表
  cpuIdEdit: "/adm/v1/cpuid/mac/edit", //编辑CPUID绑定的MAC

  /**
   * 机型云端歌曲数配置管理
   */
  SongTotalIndex: "/adm/v1/song/total/index", //获取机型云端歌曲数配置列表
  SongTotalInsert: "/adm/v1/song/total/insert", //配置机型云端歌曲数
  SongTotalDelete: "/adm/v1/song/total/delete", //删除机型云端歌曲数
  SongTotalUpdate: "/adm/v1/song/total/update", //修改机型云端歌曲数

  /**
   * YouTubeID管理
   */
  YouTubeGroupIndex: "/adm/v1/youtube/group/list", //获取TouTube组列表
  YouTubeGroupCateGoryIndex: "/adm/v1/youtube/group/category/list", //获取TouTube组下面的机型列表
  YouTubeGroupCateGoryADD: "/adm/v1/youtube/group/add", //新增YouTube组
  YouTubeGroupCateGoryEdit: "/adm/v1/youtube/group/edit", //编辑YouTube组
  YouTubeGroupCateGoryDelete: "/adm/v1/youtube/group/delete", //删除YouTube组机型

  YouTubeIndex: "/adm/v1/youtube/list", //获取TouTubeKey列表
  YouTubeKEYAdd: "/adm/v1/youtube/key/add", //添加YouTubeKEY
  YouTubeKEYDelete: "/adm/v1/youtube/key/delete", //删除YouTubeKEY
  YouTubeKEYEdit: "/adm/v1/youtube/key/edit", //编辑YouTubeKEY

  YouTubeMacAuthorizeIndex: "/adm/v1/youtube/mac_authorize/list", //获取YouTube机器授权列表
  YouTubeMacAuthorizeDelete: "/adm/v1/youtube/mac_authorize/delete", //删除授权机器
  YouTubeMacAuthorizeAdd: "/adm/v1/youtube/mac_authorize/add", //添加授权机器

  YouTubeCateGoryAuthorizeIndex: "/adm/v1/youtube/category_authorize/list", //获取YouTube机型授权列表
  YouTubeCateGoryAuthorizeAdd: "/adm/v1/youtube/category_authorize/add", //添加授权机型
  YouTubeCateGoryAuthorizeDelete: "/adm/v1/youtube/category_authorize/delete", //删除授权机型

  /**
   * 消息推送
   */
  NotificationgeList: "/adm/v1/notificationge/list", //获取消息列表
  NotificationgeMessageAdd: "/adm/v1/notificationge/message/add", //发送消息推送
  NotificationgeMessagDelete: "/adm/v1/notificationge/message/delete", //删除消息接
  NotificationgeMessagEdit: "/adm/v1/notificationge/message/edit", //编辑消息

  /**
   * 定制客户管理
   */
  CustomizedUserList: "/adm/v1/customized/user/index", //获取定制客户用户列表
  CustomizedUserModelList: "/adm/v1/customized/user/model/index", //获取定制客户账号机型列表
  CustomizedUserAdd: "/adm/v1/customized/user/add", //添加客户账号
  CustomizedUserModelDelete: "/adm/v1/customized/user/model_delete", //删除账号下的机型
  CustomizedUserModelAdd: "/adm/v1/customized/user/model_add", //新增账号下的机型
  CustomizedUserChildList: "/adm/v1/customized/user/child/index", //获取定制客户二级用户列表
  CustomizedUserChildAdd: "/adm/v1/customized/user/child/add", //添加客户二级账号
  CustomizedUserDelete: "/adm/v1/customized/user/delete", //删除账号

  /**
   * 统计管理
   */
  StatisticsMacRegisterList: "/adm/v1/statisticsMacRegister/list/macRegister", //mac机器激活数查询
  StatisticsMacActionList: "/adm/v1/statisticsMacAction/list/macAction", //开机台数查询
  StatisticsMacActionNumberList:
    "/adm/v1/statisticsMacActionNumber/list/macActionNumber", //开机次数查询
  StatisticsMacSongDownloadList:
    "/adm/v1/statisticsMacSongDownload/list/download", //下载统计查询
  StatisticVipBillTotal: "/adm/v1/statisticsVipBill/total/bill", //Vip账单统计
  StatisticsOrderVip198ServerDay: "/adm/v1/statisticsOrder/vip/ServerDay", //*VIP 198 近7天订单统计
  StatisticsOrderVipYesterday: "/adm/v1/statisticsOrder/vip/yesterday", //*VIP 昨日订单趋势
  statisticsOrderVipCustomer: "/adm/v1/statisticsOrder/vip/customer", //客户详情
  SongClickList: "/adm/v1/song/click/list", //点歌率统计
  SongDownloadList: "/adm/v1/song/download/list", //歌曲下载榜单
  StatisticVipBillTodayTotal: "/adm/v1/statisticsVipBill/today/total/bill", //今日账单

  /**
   * 3128在线升级
   */
  UpgradeVersion3128Index: "/adm/v1/3128/upgrade/version/list", //获取3128在线升级列表
  UpgradeVersion3128Add: "/adm/v1/3128/upgrade/version/add", //添加3128升级
  UpgradeVersion3128Delete: "/adm/v1/3128/upgrade/version/delete", //删除3128升级

  /**
   * 腾讯会员商品管理
   */
  TentCentVideoCodeAdd: "/adm/v1/tencent/video/code/add", //添加会员兑换码
  TenCentVideoCodeIndex: "/adm/v1/tencent/video/code/list", //会员码列表
  TenCentVideoCodePaymentIndex: "/adm/v1/tencent/video/payment/index", //订单列表

  /**
   * 歌库后台管理
   */
  SongVodIndex: "/adm/v1/song/vod/list", //获取歌单数据列表
  SongVodBatchSearch: "/adm/v1/song/file_upload/search", //文件批量查询
  SongVodFileIndex: "/adm/v1/song/file/index", //文件查询出来
  SongTgaConditionTxt: "/adm/v1/song/tag/condition/export_txt", //导出txt
  SongVodAutomation: "/adm/v1/song/vod/automation", //保存歌自动化单记录
  SongVodAutomationIndex: "/adm/v1/song/vod/automation/index", //获取歌自动化列表数据
  SongVodAutomationSynchronous: "/adm/v1/song/vod/automation/synchronous", //同步上传歌单
  SongVodBatchAdd: "/adm/v1/song/file_upload/batch_add", //文件批量添加

  /**
   * 机器下载限制管理
   */
  MacDownloadWhiteIndex: "/adm/v1/white/mac/index", //获取机器下载限制白名单列表
  MacDownloadWhiteAdd: "/adm/v1/white/mac/add", //添加机器白名单
  MacDownloadWhiteDelete: "/adm/v1/white/mac/delete", //删除机器白名单
  ModelDownloadWhiteIndex: "/adm/v1/white/model/index", //获取机型下载限制白名单列表
  ModelDownloadWhiteAdd: "/adm/v1/white/model/add", //添加机型白名单
  ModelDownloadWhiteDelete: "/adm/v1/white/model/delete", //删除机型白名单
  MacDownloadIndex: "/adm/v1/download/number/index", //获取机器每日下载数
  MacDownloadReset: "/adm/v1/download/number/reset", //重置下载

  /**
   * 报警监控
   */
  AlarmSummary: "/adm/v1/alarm/summary", //监控概览
  AlarmRuleIndex: "/adm/v1/alarm/rule/index", //报警规则
  AlarmRuleSave: "/adm/v1/alarm/rule/save", //保存规则
  AlarmRegisterNoCategory: "/adm/v1/alarm/register/nocategory", //无机型注册
  AlarmRegisterSameIp: "/adm/v1/alarm/register/sameip", //同IP集中注册
  AlarmRegisterPrefix: "/adm/v1/alarm/register/prefix", //MAC前缀集中注册
  AlarmDownloadList: "/adm/v1/alarm/download/list", //单机下载超限
  AlarmDownloadSameIp: "/adm/v1/alarm/download/sameip", //同IP下载合计
  AlarmEventIndex: "/adm/v1/alarm/event/index", //报警记录
  AlarmEventHandle: "/adm/v1/alarm/event/handle", //处理报警
  AlarmEventDetail: "/adm/v1/alarm/event/detail", //报警明细
  AlarmScan: "/adm/v1/alarm/scan", //按规则扫描并写入报警
  AlarmIpChange: "/adm/v1/alarm/ip/change", //近7天IP频繁变更

  /**
   * 临时开关功能设置
   */
  SwitchInfo: "/adm/v1/switch/info",
  Switch10Edit: "/adm/v1/switch/10_edit",
  Switch2Edit: "/adm/v1/switch/2_edit",

  /**
   * 播放下载管理
   */
  NovipModeIndex: "/adm/v1/novip/mode/index", //机型配置列表
  NovipModeGlobalConfig: "/adm/v1/novip/mode/global/config", //全局配置
  NovipModeModelAdd: "/adm/v1/novip/mode/model/add", //添加机型配置
  NovipModeModelDelete: "/adm/v1/novip/mode/model/delete", //删除机型配置
  NovipModeGlobalConfigEdit: "/adm/v1/novip/mode/global/config/edit", //修改全局配置

  /**
   * H5网页收费管理
   */
  H5payUserIndex: "/adm/v1/H5pay/user/index", //用户列表
  H5payUserAdd: "/adm/v1/H5pay/user/add", //添加用户

  /**
   * 机器服务器配置
   */
  MacServerConfigAdd: "/adm/v1/server/config/add", //机型配置
  MacServerConfigMacAdd: "/adm/v1/server/config/mac/add", //机器配置
  MacServerConfigMacMacIndex: "/adm/v1/server/config/index_mac", //机器配置列表
  MacServerConfigMacIndex: "/adm/v1/server/config/index", //机型配置列表
  MacServerConfigMacDelete: "/adm/v1/server/config/delete", //删除服务器配置

  /**
   * 酷狗管理
   */
  KugouVipMacIndex: "/adm/v1/kugou/vip/index", //获取酷狗激活列表
  KugouVipMacAvailable: "/adm/v1/kugou/vip/available/code", //获取剩余酷狗剩余可用卡数
  KugouVipMacResetting: "/adm/v1/kugou/vip/resetting", //超级重置
  KugoAuthorizeMacIndex: "/adm/v1/kugou/authorize/index", //获取酷狗授权列表
  KugoAuthorizeMacAdd: "/adm/v1/kugou/authorize/add", //添加酷狗MAC授权列表
  KugoAuthorizeMacDelete: "/adm/v1/kugou/authorize/delete", //删除酷狗MAC授权列表
  KugoMacManualActivation: "/adm/v1/kugou/vip/manual/activation", // 手动激活VIP会员,并扣点年卡220624001
  KugouVipMacBatch: "/adm/v1/kugou/vip/batch/add", //批量添加酷狗授权
  KugouVipMacToTransfer: "/adm/v1/sdk/kg/vip/transfer", //酷狗VIP转移接口
  KugouVipMacToIndex: "/adm/v1/kugou/vip/to/index", //获取酷狗VIP转移列表
  KugouSnResetIndex: "/adm/v1/kugou/vip/sn/reset/index", //获取酷狗SN重置列表
  KugouSnResetDevice: "/adm/v1/kugou/vip/sn/reset/device", //重置设备ID
  KugouMonthlyPoints: "/adm/v1/kugou/vip/monthly/points", //重置设备ID
  KugouSysnMember: "/adm/v1/kugou/vip/sync/member", //查询酷狗会员信息
  KugouSysnMemberAdd: "/adm/v1/kugou/vip/sync/member/add", //同步酷狗会员信息
  KugouVipLogIndex: "/adm/v1/kugou/vip/log/index", //查看酷狗VIP日志
  KugouVipRecycleAdd: "/adm/v1/kugou/return/recycle/add", //新增酷狗会员退货回收池
  KugouVipRecycleIndex: "/adm/v1/kugou/recycle/index", //获取酷狗回收池列表
  KugouVipRecycleDelete: "/adm/v1/kugou/recycle/delete", //删除酷狗回收池列表

  /**
   * 全民K歌管理
   */
  QuanMinKgeAuthorizeMacIndex: "/adm/v1/tencetn/qm/authorize/index",
  QuanMinKgeAuthorizeMacAdd: "/adm/v1/tencetn/qm/authorize/batch_add", //批量添加全民K歌MAC授权
  QuanMinKgeAuthorizeMacDelete: "/adm/v1/tencetn/qm/authorize/delete", //删除添加全民K歌MAC授权
  QuanMinKgeActivationIndex: "/adm/v1/tencetn/qm/activation/index", //全民K歌MAC激活列表
  QuanMinKgePaymentIndex: "/adm/v1/tencetn/qm/payment/index", //获取全民K歌支付流水信息
  QuanMinKgeGetTokenIndex: "/adm/v1/tencetn/qm/gettoken/index", //全民K歌用户级Toekn列表
  QuanMinKgeRefreshGetToken: "/adm/v1/tencetn/qm/refresh/getToken", //刷新应用级Toekn接口
  QuanMinKgeOnlineIndex: "/adm/v1/tencetn/qm/online/index", //全民K歌上线列表
  QuanMinKgePaymentTradeRefund: "/adm/v1/tencetn/qm/payment/tradeRefund", //全名K歌订单退款
  QuanMinKgeReturnExamineIndex: "/adm/v1/tencetn/qm/return/examine/index", //全民K歌退货审核申请列表
  QuanMinKgeReturnOperation: "/adm/v1/tencetn/qm/return/examine/operation", //退货操作
  QuanMinKgActivateVip: "/adm/v1/tencetn/qm/activate/vip", //手动开通会员
  QuanMinKgAvailableCode: "/adm/v1/tencetn/qm/available/code", //获取全民K歌CDK状态
  QuanMinKgeCdkApplyIndex: "/adm/v1/tencetn/qm/cdk/apply/index", //CDK使用记录列表
  QuanMinKgeRecallNewCdk:
    "/adm/v1/tencetn/qm/karaoke/payment/v2/recall_new_cdk", //退货召回
  QuanMinKgeResetDevice: "/adm/v1/tencetn/qm/reset/device", //重置
  QuanMinKgeTransfer: "/adm/v1/tencetn/qm/transfer/device/vip", //转移
  QuanMinKgeTransferDeviceIndex: "/adm/v1/tencetn/qm/transfer/index", //全民K歌设备转移列表

  /**
   * 主页定制模块
   */
  HomeCustThemeAdd: "/adm/v1/home/cust/theme/add", //新增主题类别
  HomeCustThemeList: "/adm/v1/home/cust/theme/list", //获取主题类别列表
  HomeCustThemeIntervalAdd: "/adm/v1/home/cust/theme/interval/add", //新增主题区间版本
  HomeCustThemeIntervalDelete: "/adm/v1/home/cust/theme/interval/delete", //删除主题区间版本
  HomeCustThemeIntervalList: "/adm/v1/home/cust/theme/interval/list", //获取主题区间版本列表

  HomeCustVerisonAdd: "/adm/v1/home/cust/version/add", //添加主页定制版本包
  HomeCustVerisonList: "/adm/v1/home/cust/version/list", //列表获取
  HomeCustVerisonDelete: "/adm/v1/home/cust/version/delete", //删除
  HomeCustVerisonDelete: "/adm/v1/home/cust/version/delete", //删除
  HomeCustSpecifyList: "/adm/v1/home/cust/specify/mac/list", //主页定制模块机器指定版本包列表
  HomeCustSpecifyBatchAdd: "/adm/v1/home/cust/specify/batch_add", //批量MAC指定定制模块包
  HomeCustSpecifyBatchDelete: "/adm/v1/home/cust/specify/mac/delete", //删除MAC指定定制模块包
  HomeCustSpecifyModel: "/adm/v1/home/cust/specify/model", //批量MAC指定定制模块包
  getThemeTree: "/adm/v1/home/cust/theme/tree", //获取主题区间版本树形结构

  LauncherList: "/adm/v1/home/cust/theme/interval/launcher/list", //获取Launcher预安装包列表
  LauncherAdd: "/adm/v1/home/cust/version/launcher/add", //添加Launcher预安装包
  LauncherDelete: "/adm/v1/home/cust/version/launcher/delete", //删除Launcher预安装包

  /**
   * App类型管理
   */
  AppTypesAdd: "/adm/v1/app/types/add",
  AppTypesList: "/adm/v1/app/types/index",
  AppTypesAppIdAdd: "/adm/v1/app/types/appid/add",
  AppTypesAppIdDelete: "/adm/v1/app/types/appid/delete",
  AppTypesAppIdList: "/adm/v1/app/types/appid/list",
  AppTypesAppIdVersionAdd: "/adm/v1/app/types/appid/version/add",
  getTypesAppidTree: "/adm/v1/app/types/appid/version/tree",
  AppApkVersionList: "/adm/v1/app/types/appid/version/list",
  AppApkVersionDelete: "/adm/v1/app/types/appid/version/delete",
  AppApkSpecifyList: "/adm/v1/app/types/appid/specify/mac/list",
  AppApkSpecifyBatchAdd: "/adm/v1/app/types/appid/specify/batch_add",
  AppApkSpecifyBatchDelete: "/adm/v1/app/types/appid/specify/mac/delete",
  AppApkSpecifyModel: "/adm/v1/app/types/appid/specify/model",

  /**
   * APK版本接口管理
   */
  ChannelGroupList: "/adm/v1/apk/device/channel/group/list", //渠道机型组
  LauncherAppAdd: "/adm/v1/apk/device/launcher/app/add", //上传包
  LauncherAppIndex: "/adm/v1/apk/device/launcher/list/index", //Launcher应用组更新列表
  ApkCollectionAdd: "/adm/v1/apk/collection/add", //MAC版APK上传
  ApkCollectionList: "/adm/v1/apk/collection/list", //MAC版APK列表
  ApkCollectionMacList: "/adm/v1/apk/collection/mac_list", //MAC版APK绑定MAC列表
  ApkCollectionMacAdd: "/adm/v1/apk/collection/mac/add", //MAC版APK批量新增MAC uuid,mac,remarks
  ApkCollectionMacDelete: "/adm/v1/apk/collection/mac/delete", //MAC版APK删除MAC

  /**
   * 支付订单投诉
   */
  complaintIndex: "/adm/v1/wx/complaint/list",
  complaintResponse: "/adm/v1/wx/complaint/response",
  complaintStatus: "/adm/v1/wx/complaint/status",

  //上传
  //upload_server:'/adm/v1/file/up',//通过服务器上传的接口地址
  //upload_server:'http://localhost:8001/adm/v1/system/upload',//通过服务器上传的接口地址
  //upload_server: 'http://47.112.127.252:8001/adm/v1/system/upload',//通过服务器上传的接口地址 //测试服务器
  upload_server: "http://jslpaypro.jiashilian.com:8001/adm/v1/system/upload", //通过服务器上传的接口地址 //与 API_ROOT 保持一致
  //upload_client:'https://upload.qiniup.com',//通过客户端直接上传到七牛云的接口地址

  //项目专有
  course_index: "/adm/v1/course/index",
  course_save: "/adm/v1/course/save",
  course_detail: "/adm/v1/course/detail",
  lesson_index: "/adm/v1/course/lesson-index",
  lesson_save: "/adm/v1/course/lesson-save",
  lesson_detail: "/adm/v1/course/lesson-detail",
  topic_index: "/adm/v1/course/topic-index",
  topic_save: "/adm/v1/course/topic-save",
  topic_detail: "/adm/v1/course/topic-detail",
  get_topic_news: "/adm/v1/course/get-topic-news",
  topic_news_save: "/adm/v1/course/topic-news-save",
  demo_index: "/adm/v1/course/demo-index",
  demo_save: "/adm/v1/course/demo-save",
  demo_detail: "/adm/v1/course/demo-detail",

  //webpay
  webpay_list: "/adm/v1/web/pay/server/list",
  webpay_list_add: "/adm/v1/web/pay/server/add/web_pay",
  webpay_list_update: "/adm/v1/web/pay/server/save/web_pay",
  webpay_list_del: "/adm/v1/web/pay/server/del/web_pay",
  webpay_user: "/adm/v1/web/pay/user/list",
  webpay_user_add: "/adm/v1/web/pay/user/add/list",
  cdk_list: "/adm/v1/cd_key/list",
  cdk_add: "/adm/v1/cd_key/add",
  webpay_bind: "/adm/v1/web/pay/user/bind",
  webpay_order: "/adm/v1/webpay/order/list",
  webpay_good_user: "/adm/v1/web/pay/server/user/list",
  webpay_good_user_del: "/adm/v1/web/pay/server/user/list/del",

  /**
   * 收款商户切换相关API
   */
  payment_change_index: "/adm/v1/payment/change/index",
  payment_change_weixin_type: "/adm/v1/payment/change/weixin_type",
  payment_change_alipay_type: "/adm/v1/payment/change/alipay_type",
  payment_change_sorting: "/adm/v1/payment/change/sorting",
  payment_change_h5_index: "/adm/v1/payment/change/h5/index",
  payment_change_h5_alipay_type: "/adm/v1/payment/change/h5/alipay_type",
  payment_change_h5_sorting: "/adm/v1/payment/change/h5/sorting",

  /**
   * 24年春节下载限制相关API
   */
  down_limitation_3719_index: "/adm/v1/down/limitation/3719/index",
  down_limitation_3719_switch_type: "/adm/v1/down/limitation/switch_type",
  down_limitation_3719_switch_type_edit:
    "/adm/v1/down/limitation/3719/switch_type/edit",
  down_limitation_mac_index: "/adm/v1/down/limitation/mac/index",
  down_limitation_mac_switch_type_edit:
    "/adm/v1/down/limitation/mac/switch_type/edit",

  down_limitation_white_index: "/adm/v1/down/limitation/white/index",
  down_limitation_white_add: "/adm/v1/down/limitation/white/add",
  down_limitation_white_delete: "/adm/v1/down/limitation/white/delete",

  /**
   * 音集协白名单配置
   */
  YjxWhiteModelConfigAdd: "/adm/v1/yjx/white/config/add", //机型配置
  YjxWhiteMacConfigAdd: "/adm/v1/yjx/white/config/mac/add", //机器配置
  YjxWhiteMacConfigIndex: "/adm/v1/yjx/white/config/index_mac", //机器配置列表
  YjxWhiteModelConfigIndex: "/adm/v1/yjx/white/config/index", //机型配置列表
  YjxWhiteConfigDelete: "/adm/v1/yjx/white/config/delete", //删除白名单配置
  YjxWhiteModelRecordIndex: "/adm/v1/yjx/white/record/index", //获取调用音集协管控时间列表
  YjxWhiteMacBriefConfigIndex: "/adm/v1/yjx/white/config/brief/index_mac", //临时白名单列表
  YjxWhiteMacBriefConfigAdd: "/adm/v1/yjx/white/config/brief/mac/add", //批量添加临时白名单
  YjxWhiteMacBriefConfigDelete: "/adm/v1/yjx/white/config/brief/delete", //删除临时白名单
  YjxGlobalSwitch: "/adm/v1/yjx/global/switch/get", //获取音集协全局控制开关值
  YjxGlobalSwitchLimit: "/adm/v1/yjx/global/switch/limit", //设置音集协全局控制开关值
  YjxPrepaidMacIndex: "/adm/v1/yjx/prepaid/mac/index", //音集协预付费MAC地址列表
  YjxPrepaidAdd: "/adm/v1/yjx/prepaid/brief/mac/add", //批量添加预付费MAC
  YjxPrepaidDelete: "/adm/v1/yjx/prepaid/brief/delete", //删除预付费MAC
  WechatWsIndex: "/adm/v1/machine/wechat/ws/index", //微信ws机器列表
  WechatWsAdd: "/adm/v1/machine/wechat/ws/add", //新增微信ws机器
  WechatWsDelete: "/adm/v1/machine/wechat/ws/delete", //删除微信ws机器
  /**
   * 第三套音集协逻辑
   * 音集协SDK扣费逻辑
   * 页面1：SDK扣费授权列表
   * SDK管控全局开关配置：/adm/v1/yjx/sdk/charging/global/switch  POST 参数  status （1：开启，2:关闭）
   * 获取SDK全局开关状态：/adm/v1/yjx/sdk/charging/global/switch/get  GET
   * 新增管控机型：/adm/v1/yjx/sdk/charging/config/add POST  参数 model_uuid，remarks
   * 批量新增管控MAC：/adm/v1/yjx/sdk/charging/config/mac/add POST  参数 mac，remarks  MAC不带：
   * 获取管控列表 机型与MAC：/adm/v1/yjx/sdk/charging/config/index_mac GET  参数 mac，  type1:机型，2：是MAC，page，page_size
   * 删除配置：/adm/v1/yjx/sdk/charging/config/delete POST  参数 mac， model_uuid, type1:机型，2
   */
  SDK_ChargingConfigIndexMacAPI: "/adm/v1/yjx/sdk/charging/config/index_mac", //获取管控列表 GET  参数 mac，  type1:机型，2：是MAC，page，page_size
  SDK_ChargingConfigIndexMacAddAPI: "/adm/v1/yjx/sdk/charging/config/mac/add", //批量新增管控MAC：POST  参数 mac，remarks  MAC不带：
  SDK_ChargingConfigGlobalSwitchAPI: "/adm/v1/yjx/sdk/charging/global/switch", //SDK管控全局开关配置：POST 参数  status （1：开启，2:关闭）
  SDK_ChargingConfigGlobalSwitchGetAPI:
    "/adm/v1/yjx/sdk/charging/global/switch/get", //获取SDK全局开关状态：GET
  SDK_ChargingConfigAddAPI: "/adm/v1/yjx/sdk/charging/config/add", //新增管控机型：POST  参数 model_uuid，remarks
  SDK_ChargingConfigDeleteAPI: "/adm/v1/yjx/sdk/charging/config/delete", //删除配置：POST  参数 mac， model_uuid, type1:机型，2
  /**
   * 新云猫歌单管理配置
   */
  new_song_list_type_list: "/adm/v1/new/song/list_type/list", //获取歌单类型数据
  new_song_list_data_add: "/adm/v1/new/song/list_data/add", //上传歌单数据
  new_song_list_information: "/adm/v1/new/song/list/information", //获取歌单信息数据列表
  new_song_list_information_delete: "/adm/v1/new/song/list/information_delete", //删除歌单数据
  new_song_list_type_add: "/adm/v1/new/song/list/type/add", //添加歌单类型
  new_song_list_type_delete: "/adm/v1/new/song/list/type/delete" //删除歌单类型
};



// WEBPACK FOOTER //
// ./src/utils/config/api.js